import logLevels from './levels'

export default class Queue {
  public messages: any[]

  public constructor() {
    this.messages = []
  }

  public log(params, level = logLevels.INFO) {
    this.messages.push({
      params,
      level
    })
  }

  public info(params) {
    return this.log(params, logLevels.INFO)
  }

  public error(params) {
    return this.log(params, logLevels.ERROR)
  }

  public warn(params) {
    return this.log(params, logLevels.WARN)
  }
}
